import { TButtonSize } from '@cian/ui-kit/button/types';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { PhoneButton, TPhoneButtonType } from '../../components/PhoneButton';
import { selectBuilderInfo } from '../../selectors/builder';

export interface IPhoneButtonContainerProps {
  text?: string;
  size?: TButtonSize;
  withIcon?: boolean;
  buttonType?: TPhoneButtonType;
  onShow?(): void;
}

export const PhoneButtonContainer: React.FC<IPhoneButtonContainerProps> = ({
  text,
  size,
  withIcon,
  buttonType,
  onShow,
}) => {
  const [phoneVisible, setPhoneVisible] = React.useState(false);

  const { phone } = useSelector(selectBuilderInfo);

  const handleShowPhone = React.useCallback(() => {
    setPhoneVisible(true);

    if (onShow) {
      onShow();
    }
  }, [onShow]);

  if (!phone) {
    return null;
  }

  return (
    <PhoneButton
      phone={phone}
      phoneVisible={phoneVisible}
      text={text}
      size={size}
      withIcon={withIcon}
      type={buttonType}
      onClick={handleShowPhone}
    />
  );
};
